export enum EnvironmentEnum {
	DEV = 'dev',
	PROD = 'prod'
}
